
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isToursOpen, setIsToursOpen] = useState(false);

  const tours = [
    { name: 'Evening Desert Safari', path: '/evening-desert-safari' },
    { name: 'VIP Desert Safari', path: '/vip-desert-safari' },
    { name: 'Morning Desert Safari', path: '/morning-desert-safari' },
    { name: 'Sunrise Desert Safari', path: '/sunrise-desert-safari' },
    { name: 'Quad Bike Safari', path: '/quad-bike-safari' },
    { name: 'Dirt Bike Adventure', path: '/dirt-bike-adventure' },
    { name: 'Desert Buggy Dubai', path: '/desert-buggy-dubai' },
    { name: 'Premium Desert Safari', path: '/premium-desert-safari' },
    { name: 'Half Day Desert Safari', path: '/half-day-desert-safari' }
  ];

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking-form');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <nav className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-yellow-600" style={{ fontFamily: 'Pacifico, serif' }}>
              Safari Deserts
            </h1>
          </Link>

          {/* Contact Info and Book Now */}
          <div className="flex items-center space-x-6">
            <div className="hidden md:flex items-center space-x-4 text-sm">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-yellow-500"></i>
                <span className="text-gray-700">+971-50-425-3450</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-yellow-500"></i>
                <span className="text-gray-700">dubaidesertfun@gmail.com</span>
              </div>
            </div>
            <Link 
              to="/booking" 
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-2 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Now
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-yellow-600 font-medium transition-colors">
              Home
            </Link>
            
            {/* Tours Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsToursOpen(true)}
              onMouseLeave={() => setIsToursOpen(false)}
            >
              <button className="text-gray-700 hover:text-yellow-600 font-medium transition-colors flex items-center">
                Tours
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              
              {isToursOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50">
                  {tours.map((tour, index) => (
                    <Link
                      key={index}
                      to={tour.path}
                      className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors"
                    >
                      {tour.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            
            <Link to="/about" className="text-gray-700 hover:text-yellow-600 font-medium transition-colors">
              About
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-yellow-600 font-medium transition-colors">
              Contact
            </Link>
            
            {/* Removed original Button */}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {/* Mobile Contact Info */}
              <div className="space-y-2 pb-4 border-b border-gray-200">
                <a href="tel:+971504253450" className="flex items-center text-gray-600 text-sm">
                  <i className="ri-phone-line mr-2"></i>
                  +971-50-425-3450
                </a>
                <a href="mailto:dubaidesertfun@gmail.com" className="flex items-center text-gray-600 text-sm">
                  <i className="ri-mail-line mr-2"></i>
                  dubaidesertfun@gmail.com
                </a>
              </div>

              <Link to="/" className="text-gray-700 hover:text-yellow-600 font-medium">
                Home
              </Link>
              
              <div>
                <button 
                  className="text-gray-700 hover:text-yellow-600 font-medium flex items-center w-full"
                  onClick={() => setIsToursOpen(!isToursOpen)}
                >
                  Tours
                  <i className={`ri-arrow-${isToursOpen ? 'up' : 'down'}-s-line ml-1`}></i>
                </button>
                
                {isToursOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    {tours.map((tour, index) => (
                      <Link
                        key={index}
                        to={tour.path}
                        className="block text-gray-600 hover:text-yellow-600 text-sm"
                      >
                        {tour.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              
              <Link to="/about" className="text-gray-700 hover:text-yellow-600 font-medium">
                About
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-yellow-600 font-medium">
                Contact
              </Link>
              
              <Button onClick={scrollToBooking} size="sm" className="w-fit">
                Book Now
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
